module.exports = __webpack_public_path__ + "static/media/kotlin.4ca0bb1e.svg";